import { AxiosInstance } from "axios";
import type {
  ConfluenceResource,
  ConfluenceSpace,
} from "./ConfluenceSourceSettings.types";

export class ConfluenceSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getResources(
    boardId: string,
    connectionId: string,
  ): Promise<ConfluenceResource[]> {
    const response = await this.client.get<ConfluenceResource[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/confluence/resources`,
    );

    return response.data;
  }

  async getSpaces(
    boardId: string,
    connectionId: string,
    resourceId: string,
  ): Promise<ConfluenceSpace[]> {
    const response = await this.client.get<ConfluenceSpace[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/confluence/spaces?resourceId=${encodeURIComponent(resourceId)}`,
    );

    return response.data;
  }
}
